/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.review'},
});

const ReviewerQueueItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/review"
    title={messages.title}
  />
);

export default ReviewerQueueItem;
